import { BillingActions, EBillingActions } from "@edp-store/actions/billing.actions";
import { IbillingState, initialBillingState } from "@edp-store/state/billing.state";

export function billingReducers(state = initialBillingState, action: BillingActions): IbillingState {
    switch (action.type) {
        case EBillingActions.SetMontlhyInvoices: {
            return {
                ...state,
                monthlyInvoices: action.payload,
            };
        }
        case EBillingActions.SetPaymentTab: {
            return {
                ...state,
                paymentTab: action.payload,
            };
        }
        case EBillingActions.SetTariffFiles: {
            return {
                ...state,
                tariffFiles: action.payload,
            };
        }
        default: {
            return state;
        }
    }
}
